import React from 'react';

import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';

// Shared InputLabel className for fields that clamp a long floating label to one line: `max-w-full`
// bounds the truncating label, and `z-10` is raised only while it actually overflows (surfaced as
// `data-overflowing` by the tooltip wrapper) so short labels keep the input's normal pointer
// behaviour. Field-specific end padding (e.g. select's `pe-20`, date picker's `pe-40`) is added on
// top by each caller to clear its own end-adornment.
export const SINGLE_LINE_LABEL_CLASS_NAME = 'max-w-full has-[[data-overflowing=true]]:z-10';

interface SingleLineLabelWithTooltipProps {
  label: NonNullable<React.ReactNode>;
}

// Renders a floating label through the shared ellipsis+tooltip wrapper so a long resting label stays
// on one line (instead of wrapping through the input underline and misaligning the field) and keeps
// its full text on hover. Pair with `SINGLE_LINE_LABEL_CLASS_NAME` on the field's InputLabelProps.
const SingleLineLabelWithTooltip: React.FC<SingleLineLabelWithTooltipProps> = ({ label }) => (
  <OverflowTextWithToolTip textWrapperClassName="min-h-[1.2em]" tooltipPlacement="top">
    {label}
  </OverflowTextWithToolTip>
);

export default SingleLineLabelWithTooltip;
